import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { echeqOptions } from "util/echecks";
import { actions as echeckActions } from "reducers/echecks";
import { usePrevRoute } from "hooks/usePrevRoute";
import {
    today,
    date30DaysBefore,
    date365DaysAfter,
    date365DaysBefore,
    date7DaysAfter,
    date7DaysBefore,
} from "pages/echeck/utils";

export const useEcheckTabs = (tabIndex) => {
    const { optionEcheq, echeqFilters } = useSelector((state) => state.echecks);
    const dispatch = useDispatch();
    const isTabSelected = optionEcheq === echeqOptions[tabIndex];
    const { fromOtherPage, fromPage: fromMainEcheckPage } = usePrevRoute("echecks");

    useEffect(() => {
        dispatch(echeckActions.setEcheqOption(echeqOptions[tabIndex]));
    }, [dispatch]);

    useEffect(() => {
        const receivedEcheqFilters = {
            createdFrom: date7DaysBefore,
            createdTo: today,
            payedFrom: today,
            payedTo: date7DaysAfter,
            emitted: "",
            receiver: "",
            ownership: "TODOS",
            status: "TODOS",
            number: "",
            pageNumber: 1,
            orderDirection: "ascendent",
            orderColumName: "fecha_pago",
            option: "received.echeqs",
        };
        const emitedEcheqFilters = {
            createdFrom: date365DaysBefore,
            createdTo: today,
            payedFrom: date30DaysBefore,
            payedTo: date365DaysAfter,
            emitted: "",
            receiver: "",
            ownership: "TODOS",
            status: "TODOS",
            number: "",
            pageNumber: 1,
            orderDirection: "descendent",
            orderColumName: "fecha_pago",
            option: "emitted.echeqs",
        };
        if (isTabSelected) {
            if (fromMainEcheckPage || fromOtherPage) {
                const _echeqFilters = tabIndex === 1 ? emitedEcheqFilters : receivedEcheqFilters;
                dispatch(echeckActions.setEcheqFilters(_echeqFilters));
                dispatch(echeckActions.filterEcheqList({ ..._echeqFilters }));
            } else {
                const orderDirection = tabIndex === 1 ? "descendent" : "ascendent";
                dispatch(echeckActions.filterEcheqList({ ...echeqFilters, orderDirection }));
            }
        }
    }, [dispatch, optionEcheq]);

    return { dispatch };
};

export default useEcheckTabs;
